<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="平ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入平台ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="名称">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
        <!-- <el-button size="medium" type="primary" icon="el-icon-download" @click="download(2)">导出</el-button> -->
      </div>
      <MyTable
        ref="myTableRef"
        :table-data="tableData"
        :columns="columns"
        :loading="loading"

        :total="total"
        :page-no="queryParams.pageNo"
        :page-size="queryParams.pageSize"
        @pagination-change="paginationChange"
      >
        <template #operation>
          <el-table-column fixed="right" label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="medium" class="mr10" @click="handleEdit(scope.row)">编辑</el-button>
              <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='取消'
                icon="el-icon-info"
                icon-color="red"
                title="确定要删除吗？"
                @confirm="handleDel(scope.row.id)"
              >
                <el-button slot="reference" type="text" class="PUB_BTN_RED">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </MyTable>
      <edit 
        v-if="dialogVisible" 
        :editID="editID"
		:type="queryParams.type"
        :dialogVisible="dialogVisible" 
        @NoneDlog="NoneDlog" 
        @AddOk="AddOk"
      >
      </edit>
    </el-card>
  </div>
</template>

<script>
import {apis} from "@/api/infos";
import {processErrors} from "@/utils/errorHandler";
import { Session } from "@/utils/storage";
const api = apis();
export default {
  components: {
    Edit:()=>import('./edit.vue')
  },
  data() {
    return {
      columns:[
        {
          label: 'ID',
          prop: 'id',
          width: '80',
        },
        {
          label: '名称',
          prop: 'name',
        },
        {
          label: '排序',
          prop: 'listorder',
          width: '120',
        }
      ],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
		type: 2,
        name: "",
        id:'',
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      editID: "",
      // 总条数
      total: 0,
      dialogVisible: false,
      loading: false,
    };
  },
  created() {
    this.getList()
  },
  methods: {
    objectToQueryString(obj) {
      const params = new URLSearchParams();
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          params.append(key, obj[key]);
        }
      }
      return params.toString();
    },
    download(type){
      let that = this;
      this.$confirm('确认导出所有数据吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 处理日期范围
        let params = that.queryParams;
        params.token = Session.get('token')
        // 获取基础 URL
        const baseExportUrl = process.env.VUE_APP_BASE_API + 'admin/rc/category/export';
        console.log(baseExportUrl, params);
        
        // 拼接 URL 参数
        window.location.href = baseExportUrl + '?' + this.objectToQueryString(params)
      }).catch(() => { })
    },
    getList(type) {
      this.loading = true
      if (type != 'changePage') {
        this.queryParams.pageNo = 1
      }
      
      api.ApiCategoryList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    paginationChange({pageNo, pageSize}){
      this.queryParams.pageNo = pageNo
      this.queryParams.pageSize = pageSize
      this.getList('changePage')
    },
    search() {
      this.getList()
    },
    handleDel(id){
      api.ApiCategoryDel({id}).then(res=>{
        if (res.code == 0) { 
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList('changePage')
        }
      })
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
		type: 2,
        name: "",
        id:''
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.dialogVisible = true
    },
    NoneDlog() {
      this.dialogVisible = false
    },
    AddOk() {
      this.editID = ""
      this.dialogVisible = false
      this.getList()
    },
    handleEdit(row) {
      this.editID = row.id
      this.dialogVisible = true
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

::v-deep .el-radio input[aria-hidden="true"] {
  display: none !important;
}
</style>